import { store } from "src/common/toolkit/store";
import { Post } from "../services";

const reportLog = async ({
  error,
  location,
  body,
}: {
  error: { message: string };
  location: string;
  body: object;
}) => {
  const user =
    store.getState().user?.data?.payload?.email ||
    `${store.getState().user?.data?.payload?.first_name} ${
      store.getState().user?.data?.payload?.last_name
    }` ||
    "N/A";
  const phone = store.getState().user?.data?.payload?.phone || "N/A";
  try {
    if (store.getState().auth?.data?.t) {
      await Post("/logs", {
        error: error?.message,
        location,
        body,
        user,
        phone,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export { reportLog };
